import { ChartLayoutConfig } from '../common/layout-config';
import { DefaultChartLayoutOptionsBuilder } from './default-chart-layout-options';
import { chartType } from '../../constants';
import { ChartLayoutOptionsBuilder } from 'app/components/favourite-layout/favourite/chart-layout-options/chart-layout-options-builder';

export function createChartLayoutOptionsBuilder(layoutConfig: ChartLayoutConfig): ChartLayoutOptionsBuilder {
  switch (layoutConfig.chartType()) {
    case chartType.LINE:
    case chartType.COLUMN:
    case chartType.BAR:
    case chartType.PIE:
    case chartType.HEATMAP:
      return new DefaultChartLayoutOptionsBuilder(layoutConfig);
    default:
      return null;
  }
}
